import { AssetDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/asset_events_pb';
import { AssetStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/asset_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { assetStatusLabels } from '../enumLabels';

const getStatusColor = (status: AssetStatus): ThemeColor => {
  switch (status) {
    case AssetStatus.INVENTORY:
      return 'primary';
    case AssetStatus.DEPLOYED:
      return 'success';
    case AssetStatus.IN_TRANSIT:
      return 'teal';
    case AssetStatus.OUT_OF_ORDER:
      return 'failure';
    default:
      return 'neutral';
  }
};

type AssetDeletedDetailProps = {
  event: AssetDeletedEvent;
};

export const AssetDeletedDetail = ({ event }: AssetDeletedDetailProps) => {
  const asset = event.asset;

  if (!asset) {
    return (
      <Col className="@AssetDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@AssetDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Asset
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={asset.id?.value} />
          <FieldDisplay label="Identifier" value={asset.identifier} />
          <BadgeField
            label="Status"
            value={assetStatusLabels[asset.status]}
            color={getStatusColor(asset.status)}
          />
          <FieldDisplay label="Description" value={asset.description} />
          <IDField label="Account ID" value={asset.accountId?.value} />
          <IDField label="Facility ID" value={asset.facilityId?.value} />
          <IDField label="Type ID" value={asset.typeId?.value} />
        </div>
      </Col>
    </Col>
  );
};
